class MasonryGrid extends HTMLElement {
  constructor() {
    super();
    this.columnCount = parseInt(this.getAttribute('columns')) || 2;
    this.gap = parseInt(this.getAttribute('gap')) || 40;
    this.onResize = this.onResize.bind(this);
  }

  connectedCallback() {
    requestAnimationFrame(() => this.layoutIfVisible());
    window.addEventListener('resize', this.onResize);
    this.observeTabChanges();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    if (this.tabObserver) this.tabObserver.disconnect();
  }

  onResize() {
    this.layoutIfVisible();
  }

  layoutIfVisible() {
    if (this.offsetParent !== null) {
      this.layout();
    }
  }

  layout() {
    const container = this;
    const items = Array.from(container.children);
    const viewportWidth = window.innerWidth;

    // 🔹 Disable Masonry below 990px
    if (viewportWidth <= 990) {
      container.style.height = "auto";
      container.style.position = "relative";

      items.forEach(item => {
        item.style.width = "100%";
        item.style.transform = "none";
        item.style.position = "relative";
        item.style.marginBottom = `${this.gap}px`;
      });
      return;
    }

    // 🔹 Regular Masonry logic
    const columnHeights = new Array(this.columnCount).fill(0);
    const containerWidth = container.clientWidth;
    const columnWidth = (containerWidth - this.gap * (this.columnCount - 1)) / this.columnCount;

    let maxHeight = 0;

    items.forEach(item => {
      if (item.classList.contains("video__tab-main")) return;

      const minCol = columnHeights.indexOf(Math.min(...columnHeights));
      const x = (columnWidth + this.gap) * minCol;
      const y = columnHeights[minCol];

      item.style.width = `${columnWidth}px`;
      item.style.transform = `translate(${x}px, ${y}px)`;
      item.style.position = "absolute";

      columnHeights[minCol] += item.offsetHeight + this.gap;
      maxHeight = Math.max(maxHeight, columnHeights[minCol]);
    });

    const videoTab = container.querySelector(".video__tab-main");
    if (videoTab) {
      videoTab.style.width = "100%";
      videoTab.style.transform = `translate(0px, ${maxHeight}px)`;
      videoTab.style.position = "absolute";
      const videoHeight = videoTab.getBoundingClientRect().height || 0;
      maxHeight += videoHeight + this.gap;
    }

    container.style.height = maxHeight + "px";
    container.style.position = "relative";
  }

  observeTabChanges() {
    this.tabObserver = new MutationObserver(() => this.layoutIfVisible());
    this.tabObserver.observe(this, { attributes: true, subtree: true });
  }
}

if (!customElements.get("masonry-grid")) {
  customElements.define("masonry-grid", MasonryGrid);
}
